import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  value?: string;
}

export const ColorInputListItemValue: React.FC<Props> = ({ value }) => {
  const [styles] = useStyles();
  return value ? (
    <View style={styles.valueContainer}>
      <Text style={[TYPOGRAPHY.p, styles.valueText]}>{value}</Text>
      <View style={[styles.value, { backgroundColor: value }]} />
    </View>
  ) : (
    <Text style={TYPOGRAPHY.p}>--</Text>
  );
};

const useStyles = createStyles((theme) => ({
  value: {
    borderColor: theme.colors.stroke,
    borderRadius: 4,
    borderWidth: 1,
    height: 20,
    marginLeft: 8,
    width: 20,
  },
  valueContainer: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  valueText: {
    textTransform: 'uppercase',
  },
}));
